import { useMemo, useState } from 'react';

import type { MediaPlan } from '@mint-sdk/api-media-plan';

import { useSidebarTreeApi } from '../../../../../../api/queries/useSidebarTreeApi.js';

export const useActivitySelection = () => {
  const { data: sidebar } = useSidebarTreeApi();
  const activities: MediaPlan.SidebarItem[] = sidebar?.subItems ?? [];

  const [selectedActivityId, setSelectedActivityId] = useState<
    string | undefined
  >();

  const activity = useMemo(
    () => activities.find((item) => item.activityId === selectedActivityId),
    [activities, selectedActivityId],
  );

  const isSelectionIncomplete = !selectedActivityId;

  return {
    activities,
    selectedActivityId,
    onActivityChange: setSelectedActivityId,
    activity,
    isSelectionIncomplete,
  };
};
